import breakpointValues from "@store/Framework/Common/Utilities/breakpointValues";
import { css } from "styled-components";

export const productDetailsFormWrapperStyles = () => {
    return css`
        ${({ theme }) => css`
            ${breakpointValues(theme.design.form.grid.small.vertical, ["margin-top", "margin-bottom"])}
        `}

        &:first-child {
            margin-top: 0;
        }

        &:last-child {
            margin-bottom: 0;
        }
    `;
};
